import {
  MarketWatchDetailService,
  StockDetail,
} from "./../../services/market-watch-detail.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ChangeDetectorRef,Component, ElementRef, Input, OnInit, ViewChild, Renderer2 } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { TranslateService } from "@ngx-translate/core";
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { CompanyList,CompanyListWithUpdates  } from "src/app/models/company-list";
import { AccountService } from "src/app/services/account.service";
														  
import { FavService } from "src/app/services/fav.service";
import { GridsterService } from "src/app/services/gridster.service";
import { SignalRService } from "src/app/services/signalr.service";
import { OrderBuyComponent } from "../order-buy/order-buy.component";
import { ApiService } from "src/app/services/api.service";
import { FlexLayoutService } from "src/app/services/flex-layout.service";
import Swal from 'sweetalert2';
import isEqual from 'lodash/isEqual';
import { Account } from "src/app/screens/user-profile/client-data";
import { ToastrService } from "ngx-toastr";
import { UrlConstants } from "src/app/models/urlConstants";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-slick-market-watch",
  templateUrl: "./slick-market-watch.component.html",
  styleUrls: ["./slick-market-watch.component.scss"],
})
export class SlickMarketWatchComponent implements OnInit {

  fireFunction: any;
  addWidget: any;
  @Input() state;
  @Input() id;
  isCompaniesLoading: boolean;
  egxCompanies: CompanyListWithUpdates [] = [];
  favCompanies = new MatTableDataSource<CompanyList>();
  favCompaniesWithUpdates = new MatTableDataSource<CompanyListWithUpdates>();
  searchText = "";
  selectedSymbol: any;
  ColumnMode = ColumnMode;
  searchComp = new MatTableDataSource<CompanyList>();
  searchCompWithUpdates = new MatTableDataSource<CompanyListWithUpdates >();
  selected;
  SelectionType = SelectionType;
  flashingVolumeNumber: string;
  flashingOrderNumber: string;
  flashingPriceNumber: string;
  flashingType: string;
  isFlashing: boolean = false;
  flashingIndex: number | null = null;
  flashDirection: 'up' | 'down' | null = null;
  previousValues: { [key: number]: { orderPrice: number; volumeTraded: number } } = {};
							  
							  
					   
  isShow: boolean = false;
									  
											  
																					   

  @ViewChild("myWidget") myWidget: ElementRef;
																 
									

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('favMenu') favMenu: ElementRef | undefined;
  @ViewChild('MatTable') table: MatTable<CompanyListWithUpdates>;
  dropdownX = 0;
  dropdownY = 0;
  selectedItem = null;
  public contextmenuX: any;
  public contextmenuY: any;
  public contextmenu = false;
  addWidgetSymbolCode: any;
  isDarkTheme: boolean;
  marketWatches: any[] = [];
  activeMarketWatch: any = null;
  favSymbols: string[] = [];
  openDropdowns: { [key: string]: boolean } = {};
  dropdownOpen: boolean = false;
  deletingMarketWatch: boolean = false;
  defaultMarketWatch: any;
  relationCode: string = '';

  columns = [];

  matColumns = [
    "Reuters",
    "ENG_NAME",
    "LAST_TRADE_PRICE",
    "LAST_TRADE_VOLUME",
    "LAST_CHANGE",
    "LAST_CHANGE_PRC",
    "OPEN_PRICE",
    "CLOSE_PRICE",
    "LOW_PRICE",
    "HIGH_PRICE",
    "TOTAL_VALUE",
    "TOTAL_VOLUME",
    "LAST_TRADE_DATE",
    "BID_PRICE",
    "BID_VOLUME",
    "TOTAL_BIDS",
    "TOTAL_ASKS",
    "ASK_VOLUME",
    "ASK_PRICE",
    "ENG_DESC",
    "MARKET_ID",
    "PREVIOUS_CLOSE",
    "REF_PRICE",
  ];

  allFilters = [
    { prop: "LAST_TRADE_PRICE", name: "last-price", isChecked: true },
    { prop: "LAST_TRADE_VOLUME", name: "last-volume", isChecked: true },
    { prop: "LAST_CHANGE", name: "last-change", isChecked: true },
    { prop: "LAST_CHANGE_PRC", name: "last-change-prc", isChecked: true },
    { prop: "OPEN_PRICE", name: "open", isChecked: true },
    { prop: "CLOSE_PRICE", name: "close", isChecked: true },
    { prop: "LOW_PRICE", name: "low", isChecked: true },
    { prop: "HIGH_PRICE", name: "high", isChecked: true },
    { prop: "TOTAL_VALUE", name: "value", isChecked: true },
    { prop: "TOTAL_VOLUME", name: "volume", isChecked: true },
    { prop: "BID_PRICE", name: "bid-price", isChecked: true },
    { prop: "BID_VOLUME", name: "bid-qty", isChecked: true },
    { prop: "TOTAL_BIDS", name: "total-bids", isChecked: true },
    { prop: "TOTAL_ASKS", name: "total-asks", isChecked: true },
    { prop: "ASK_VOLUME", name: "ask-qty", isChecked: true },
    { prop: "ASK_PRICE", name: "ask-price", isChecked: true },
    { prop: "LAST_TRADE_DATE", name: "last-trade-date", isChecked: false },
    { prop: "ENG_DESC", name: "sector", isChecked: false },
    { prop: "MARKET_ID", name: "market", isChecked: false },
    { prop: "PREVIOUS_CLOSE", name: "prev-close", isChecked: false },
    { prop: "REF_PRICE", name: "ref-price", isChecked: false },
    // {
    //   prop: "ARB_NAME",
    //   name: "shortname",
    //   isChecked: false,
    // },
    { prop: "INDICATIVEPRICE", name: "indicative-price", isChecked: true },
    { prop: "INDICATIVEVOLUME", name: "indicative-volume", isChecked: true },
  ];

  tableView = "market";
  favView = "grid";

  companiesUpdates: CompanyListWithUpdates [] = [];
  isFavsLoading: boolean = false;
  layerX: any;
  layerY: any;
  screenX: any;
  screenY: any;

  companies = new MatTableDataSource<CompanyList>();
  companiesWithUpdates = new MatTableDataSource<CompanyListWithUpdates>();
  allMarketNames: StockDetail[];
  isMarketUser: boolean;
  showAddFavorite = false;
  newFavoriteName = '';
  accList: Account[];

  private outsideClickUnlistener: () => void;
  AccFullMarket: boolean;

  addWidgets(name) {
    this._gridService.addGeneric(name, true);
  }

  public onFavViewChange(val: string) {
    this.favView = val;
    this.fetchFavs();
  }
  toggleFavMenu() {
    this.isShow = !this.isShow;
  }
  clickedOutsideMenu() {
    this.contextmenu = false;
  }

										  

  public onTableContextMenu(event, company) {

    const tableContainer = this.myWidget.nativeElement;
    const rect = tableContainer.getBoundingClientRect();

    // Calculate the context menu position
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;

    this.contextmenu = true;
    this.addWidgetSymbolCode = {
      symbol: company.SYMBOL_CODE,
      reuters: company.Reuters,
      name: company.ARB_NAME,
      nameEn: company.ENG_NAME,
    };
    const existingMenu = document.querySelector('.contextmenu') as HTMLElement;
    if (existingMenu) {
      // Update position
      existingMenu.style.left = `${this.contextmenuX}px`;
      existingMenu.style.top = `${this.contextmenuY}px`;

      // Ensure it's appended to the body
      if (existingMenu.parentNode) {
        existingMenu.parentNode.removeChild(existingMenu);
      }
      document.body.appendChild(existingMenu);
    }
    event.preventDefault();
    event.stopPropagation();
  }
  public onDropdownClick(event: MouseEvent, symbol: string): void {
    this.openDropdowns = {};
    this.openDropdowns[symbol] = !this.openDropdowns[symbol];
    this.isShow = !this.isShow;


    const dropdownMenu = document.querySelector('.dropdown-menu-fav') as HTMLElement;
    if (dropdownMenu) {
      dropdownMenu.style.left = `${event.clientX - 60}px`;
      dropdownMenu.style.top = `${event.clientY}px`;
      if (dropdownMenu.parentNode) {
        dropdownMenu.parentNode.removeChild(dropdownMenu);
      }
      document.body.appendChild(dropdownMenu);
    }
    if (this.outsideClickUnlistener) {
      this.outsideClickUnlistener();
    }
    this.outsideClickUnlistener = this.renderer.listen('document', 'click', (e: MouseEvent) => this.handleOutsideClick(e, symbol));
  }

  private handleOutsideClick(event: MouseEvent, symbol: string): void {
    const clickedInsideDropdown = (event.target as HTMLElement).closest('.dropdown-menu-fav');
    const clickedDropdownToggle = (event.target as HTMLElement).classList.contains('dropdown-toggle');

    if (!clickedInsideDropdown && !clickedDropdownToggle) {
      const dropdownMenu = document.querySelector('.dropdown-menu-fav');
      if (dropdownMenu && dropdownMenu.parentNode) {
        dropdownMenu.parentNode.removeChild(dropdownMenu);
      }

      this.openDropdowns[symbol] = false;
      if (this.outsideClickUnlistener) {
        this.outsideClickUnlistener();
        this.outsideClickUnlistener = null;
      }
    }
  }
  isNumber(val): boolean {
    return typeof val === "number";
  }

  getColumnClass(column, value) {
    if (
      (column.prop == "LAST_CHANGE_PRC" && value > 0) ||
      (column.prop == "LAST_CHANGE" && value > 0)
    )
      return "green";
    else if (
      (column.prop == "LAST_CHANGE_PRC" && value < 0) ||
      (column.prop == "LAST_CHANGE" && value < 0)
    )
      return "red";
    else if (column.prop == "LAST_TRADE_PRICE") return "last-price-color";
    else if (
      column.prop == "BID_PRICE" ||
      column.prop == "BID_VOLUME" ||
      column.prop == "TOTAL_BIDS"
    )
      return "table-bids-color";
    else if (
      column.prop == "ASK_PRICE" ||
      column.prop == "ASK_VOLUME" ||
      column.prop == "TOTAL_ASKS"
    )
      return "table-asks-color";
    return;
  }

  onSelect(item) {
    this.selected = item;
    this.sendCompanySymbol(
      item.SYMBOL_CODE,
      item.Reuters,
      item.eng_shortname,
      item.arb_shortname,
      false
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.updateCols();
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    let temp;
    if (this.tableView == "market")
      temp = this.companiesWithUpdates?.data.filter(function (d) {
        return (
          d.eng_shortname &&
          (d.eng_shortname
            .toLocaleLowerCase()
            .includes(val.toLocaleLowerCase()) ||
            d.arb_shortname
              .toLocaleLowerCase()
              .includes(val.toLocaleLowerCase()) ||
            d.SYMBOL_CODE.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.Reuters.toLocaleLowerCase().includes(val.toLocaleLowerCase()))
        );
      });
    else
      temp = this.favCompaniesWithUpdates?.data.filter(function (d) {
        return (
          d.ENG_NAME &&							
          (d.ENG_NAME.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
            d.ARB_NAME.toLocaleLowerCase().includes(val.toLocaleLowerCase()) ||
            d.SYMBOL_CODE.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.Reuters.toLocaleLowerCase().includes(val.toLocaleLowerCase()))
        );
      });
    // update the rows
    this.searchCompWithUpdates.data = temp;
    this.searchCompWithUpdates.sort = this.sort;

    this.WindowResize();

    if (val == "") {
      this.searchCompWithUpdates = new MatTableDataSource<CompanyListWithUpdates>();
    }
  }
  flashingData: {
    index: number;
    flashType: string;
    type: string;
    direction: string;
    LAST_TRADE_PRICE?: string;
    LAST_TRADE_VOLUME?: string;
    LAST_CHANGE?: string;
    LAST_CHANGE_PRC?: string;
    OPEN_PRICE?: string;
    CLOSE_PRICE?: string;
    LOW_PRICE?: string;
    HIGH_PRICE?: string;
    TOTAL_VALUE?: string;
    TOTAL_VOLUME?: string;
    LAST_TRADE_DATE?: string;
    BID_PRICE?: string;
    BID_VOLUME?: string;
    TOTAL_BIDS?: string;
    TOTAL_ASKS?: string;
    ASK_VOLUME?: string;
    ASK_PRICE?: string;
  }[] = [];				 	   

  constructor(
    private _gridService: FlexLayoutService,
    signalService: SignalRService,
    public dialog: MatDialog,
    public translate: TranslateService,
    public accService: AccountService,
    private _service: ApiService,
    private _marketDetail: MarketWatchDetailService,
    private renderer: Renderer2,
    private favService: FavService,
    private toastr: ToastrService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef

  ) {
    signalService.marketStatusChanges.subscribe((isActive) => {
      if (
        isActive &&
        this.state == "Most Active" &&
        this.companies.data.length == 0
      )
        this.fetchTodayActive();
    });
    signalService.marketChanges.subscribe((res) => {
      if (this.allMarketNames)
        res.forEach((update) => {
          switch (this.tableView) {
            case "market": {
              if (this.searchCompWithUpdates.data.length > 0) {
                let itemIndex = this.searchCompWithUpdates?.data.findIndex(
                  (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
                );
                if (
                  this.searchCompWithUpdates.data[itemIndex] != update &&
                  itemIndex != -1
                ) {
																											   
				this.applyNewFlashLogic(update, this.searchCompWithUpdates.data[itemIndex]);																		  
                  this.searchCompWithUpdates.data[itemIndex] = update;
                  this.searchCompWithUpdates.data[itemIndex].isUpdate = true;
                }
                this.updateStockDetail(this.searchCompWithUpdates.data[itemIndex]);
              } else {
                let itemIndex = this.companiesWithUpdates?.data.findIndex(
                  (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
                );
                if (
                  this.companiesWithUpdates.data[itemIndex] != update &&
                  itemIndex != -1
                ) {
																											  
				this.applyNewFlashLogic(update, this.companiesWithUpdates.data[itemIndex]);																		 
                  this.companiesWithUpdates.data[itemIndex] = update;
                  this.companiesWithUpdates.data[itemIndex].isUpdate = true;
                }
                this.updateStockDetail(this.companiesWithUpdates.data[itemIndex]);
              }
            }
            case "favorites": {
              let itemIndex = this.favCompaniesWithUpdates?.data.findIndex(
                (item) => item.SYMBOL_CODE == update.SYMBOL_CODE
              );
              if (
                this.favCompaniesWithUpdates.data[itemIndex] != update &&
                itemIndex != -1
              ) {
																												  
					this.applyNewFlashLogic(update, this.favCompaniesWithUpdates.data[itemIndex]);																		  
                this.favCompaniesWithUpdates.data[itemIndex] = update;
                this.favCompaniesWithUpdates.data[itemIndex].isUpdate = true;
                this.updateStockDetail(this.favCompaniesWithUpdates.data[itemIndex]);
              }
              this.favCompaniesWithUpdates.sort = this.sort;
            }
          }
        });
      else if (this._marketDetail.marketNames)
        this.allMarketNames = this._marketDetail.marketNames.getValue();
      this._marketDetail.namesSubject.subscribe((res) => {
        this.allMarketNames = res as StockDetail[];
      });

      if (this.tableView == "market" && this.searchCompWithUpdates.data.length > 0){
        this.searchCompWithUpdates.data = [...this.searchCompWithUpdates?.data];
								 this.cdr.detectChanges();
	   }
      else if (this.tableView == "market"){
        this.companiesWithUpdates.data = [...this.companiesWithUpdates?.data];
this.cdr.detectChanges();}
	   
      if (this.tableView == "favorites" && this.favCompaniesWithUpdates)
        this.favCompaniesWithUpdates.data = [...this.favCompaniesWithUpdates?.data];
    });
 if (this._marketDetail.marketNames)
      this.allMarketNames = this._marketDetail.marketNames.getValue();
    this._marketDetail.namesSubject.subscribe((res) => {
      this.allMarketNames = res as StockDetail[];
    });
  }
  applyNewFlashLogic(newData, oldData) {
    const setUpdateField = (newValue, oldValue, key) => {
      if (newValue > oldValue) {
        newData[key + '_UPDATED'] = 2; 
      } else if (newValue < oldValue) {
        newData[key + '_UPDATED'] = 1; 
      } else {
        newData[key + '_UPDATED'] = 0; 
      }
    };

    setUpdateField(newData.LAST_TRADE_PRICE, oldData.LAST_TRADE_PRICE, 'LAST_TRADE_PRICE');
    setUpdateField(newData.LAST_TRADE_VOLUME, oldData.LAST_TRADE_VOLUME, 'LAST_TRADE_VOLUME');
    setUpdateField(newData.LAST_CHANGE, oldData.LAST_CHANGE, 'LAST_CHANGE');
    setUpdateField(newData.LAST_CHANGE_PRC, oldData.LAST_CHANGE_PRC, 'LAST_CHANGE_PRC');
    setUpdateField(newData.CLOSE_PRICE, oldData.CLOSE_PRICE, 'CLOSE_PRICE');
    setUpdateField(newData.LOW_PRICE, oldData.LOW_PRICE, 'LOW_PRICE');
    setUpdateField(newData.HIGH_PRICE, oldData.HIGH_PRICE, 'HIGH_PRICE');
    setUpdateField(newData.TOTAL_VALUE, oldData.TOTAL_VALUE, 'TOTAL_VALUE');
    setUpdateField(newData.TOTAL_VOLUME, oldData.TOTAL_VOLUME, 'TOTAL_VOLUME');
    setUpdateField(newData.LAST_TRADE_DATE, oldData.LAST_TRADE_DATE, 'LAST_TRADE_DATE');
    setUpdateField(newData.BID_PRICE, oldData.BID_PRICE, 'BID_PRICE');
    setUpdateField(newData.BID_VOLUME, oldData.BID_VOLUME, 'BID_VOLUME');
    setUpdateField(newData.TOTAL_BIDS, oldData.TOTAL_BIDS, 'TOTAL_BIDS');
    setUpdateField(newData.TOTAL_ASKS, oldData.TOTAL_ASKS, 'TOTAL_ASKS');
    setUpdateField(newData.ASK_VOLUME, oldData.ASK_VOLUME, 'ASK_VOLUME');
    setUpdateField(newData.ASK_PRICE, oldData.ASK_PRICE, 'ASK_PRICE');
  }
  async processFlashingLogic(newDataList: any[], oldDataList: any[], type: string, originalIndex: number) {
    this.flashingData = [];
    setTimeout(() => {
      for (let index = 0; index < newDataList.length; index++) {
        const newData = newDataList[index];
        const oldData = oldDataList[index];

        if (!isEqual(oldData, newData)) {
          this.applyFlashLogic(newData, oldData, originalIndex, type);
        }
      }
    }, 50);
  }

  applyFlashLogic(newData, oldData, index, type) {
    const flashData: {
      index: number;
      type: string;
      direction: string | null;
      LAST_TRADE_PRICE: string | null;
      LAST_TRADE_VOLUME: string | null;
      LAST_CHANGE: string | null;
      LAST_CHANGE_PRC: string | null;
      OPEN_PRICE: string | null;
      CLOSE_PRICE: string | null;
      LOW_PRICE: string | null;
      HIGH_PRICE: string | null;
      TOTAL_VALUE: string | null;
      TOTAL_VOLUME: string | null;
      LAST_TRADE_DATE: string | null;
      BID_PRICE: string | null;
      BID_VOLUME: string | null;
      TOTAL_BIDS: string | null;
      TOTAL_ASKS: string | null;
      ASK_VOLUME: string | null;
      ASK_PRICE: string | null;
      flashType: string | null;
    } = {
      index,
      type,
      direction: null,
      LAST_TRADE_PRICE: null,
      LAST_TRADE_VOLUME: null,
      LAST_CHANGE: null,
      LAST_CHANGE_PRC: null,
      OPEN_PRICE: null,
      CLOSE_PRICE: null,
      LOW_PRICE: null,
      HIGH_PRICE: null,
      TOTAL_VALUE: null,
      TOTAL_VOLUME: null,
      LAST_TRADE_DATE: null,
      BID_PRICE: null,
      BID_VOLUME: null,
      TOTAL_BIDS: null,
      TOTAL_ASKS: null,
      ASK_VOLUME: null,
      ASK_PRICE: null,
      flashType: null,
    };

    const checkChange = (newValue, oldValue, key) => {
      if (newValue !== oldValue) {
        flashData[key] = newValue;
        flashData.direction = newValue > oldValue ? 'up' : 'down';
        flashData.flashType = key;
        if (!this.isFlashingIndex(index, flashData.flashType, type, flashData.direction)) {
          this.triggerFlash(flashData, index, flashData.flashType);
        }

      }
    };
    checkChange(newData.LAST_TRADE_PRICE, oldData.LAST_TRADE_PRICE, 'LAST_TRADE_PRICE');
    checkChange(newData.LAST_TRADE_VOLUME, oldData.LAST_TRADE_VOLUME, 'LAST_TRADE_VOLUME');
    checkChange(newData.LAST_CHANGE, oldData.LAST_CHANGE, 'LAST_CHANGE');
    checkChange(newData.LAST_CHANGE_PRC, oldData.LAST_CHANGE_PRC, 'LAST_CHANGE_PRC');
    checkChange(newData.OPEN_PRICE, oldData.OPEN_PRICE, 'OPEN_PRICE');
    checkChange(newData.CLOSE_PRICE, oldData.CLOSE_PRICE, 'CLOSE_PRICE');
    checkChange(newData.LOW_PRICE, oldData.LOW_PRICE, 'LOW_PRICE');
    checkChange(newData.HIGH_PRICE, oldData.HIGH_PRICE, 'HIGH_PRICE');
    checkChange(newData.TOTAL_VALUE, oldData.TOTAL_VALUE, 'TOTAL_VALUE');
    checkChange(newData.TOTAL_VOLUME, oldData.TOTAL_VOLUME, 'TOTAL_VOLUME');
    checkChange(newData.LAST_TRADE_DATE, oldData.LAST_TRADE_DATE, 'LAST_TRADE_DATE');
    checkChange(newData.BID_PRICE, oldData.BID_PRICE, 'BID_PRICE');
    checkChange(newData.BID_VOLUME, oldData.BID_VOLUME, 'BID_VOLUME');
    checkChange(newData.TOTAL_BIDS, oldData.TOTAL_BIDS, 'TOTAL_BIDS');
    checkChange(newData.TOTAL_ASKS, oldData.TOTAL_ASKS, 'TOTAL_ASKS');
    checkChange(newData.ASK_VOLUME, oldData.ASK_VOLUME, 'ASK_VOLUME');
    checkChange(newData.ASK_PRICE, oldData.ASK_PRICE, 'ASK_PRICE');
  }

  triggerFlash(flashData, index, flashType) {
    this.flashingData.push({ index, flashType, direction: flashData.direction, ...flashData });
    this.table.renderRows();
    this.cdr.detectChanges();

    setTimeout(() => {
      this.removeFlash(index, flashType);
    }, 1000);
  }

  removeFlash(index: number, flashType: string) {
    this.flashingData = this.flashingData.filter(flash => flash.index !== index || flash.flashType !== flashType);
    this.cdr.detectChanges();
  }

  isFlashingIndex(index: number, flashType: string, type: string, direction: string): boolean {
    return this.flashingData.some(flash => flash.index === index && flash.flashType === flashType && flash.type === type && flash.direction === direction);
  }

  getFlashingNumber(index: number, type: string): string | null {
    const flash = this.flashingData.find(flash => flash.index === index && flash.type === type);
    return flash ? flash[type] : null;
  }																							

  updateStockDetail(stock: CompanyListWithUpdates) {
    if (stock?.SYMBOL_CODE && this.allMarketNames) {
      let companyDetail = this.allMarketNames.find(
        (x) => x["SYMBOL_CODE"] === stock.SYMBOL_CODE
      );
      if (companyDetail) {
        stock.arb_shortname = companyDetail["arb_shortname"];
        stock.eng_shortname = companyDetail["eng_shortname"];
        stock.Reuters = companyDetail["Reuters"];
      }
    }
  }

  setMarketWatchDefault(watch: any): void {
    const title = this.translate.currentLang !== "ar" ? 'Set as Default?' : 'تعيين كافتراضي؟';
    const text = this.translate.currentLang !== "ar" ?
      `Do you want to set "${watch.MarketWatchName}" as your default market watch?` :
      `هل تريد تعيين "${watch.MarketWatchName}" كقائمة المراقبة الافتراضية؟`;
    const confirmBtn = this.translate.currentLang !== "ar" ? 'Yes, set as default!' : 'نعم، عيّنه كافتراضي!';
    const cancelBtn = this.translate.currentLang !== "ar" ? 'Cancel' : 'إلغاء';
    const successTitle = this.translate.currentLang !== "ar" ? 'Success!' : 'تم بنجاح!';
    const successText = this.translate.currentLang !== "ar" ?
      'Market watch set as default successfully.' :
      'تم تعيين قائمة المراقبة كافتراضية بنجاح';
    const errorTitle = this.translate.currentLang !== "ar" ? 'Error!' : 'خطأ!';
    const errorText = this.translate.currentLang !== "ar" ?
      'Failed to set default market watch.' :
      'فشل في تعيين قائمة المراقبة الافتراضية';
    const confirmBtnText = this.translate.currentLang !== "ar" ? 'OK' : 'حسنا';

    Swal.fire({
      title: title,
      text: text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmBtn,
      cancelButtonText: cancelBtn
    }).then((result) => {
      if (result.isConfirmed) {
        // Get current favorite symbols
        const symbols = [...this.favService.favCompaniesSymbols.getValue()];

        try {
          // Use the same updateFavs method - assuming the 4th parameter controls default setting
          this.favService.updateFavs(symbols, watch.MarketWatchID, watch.MarketWatchName, true);

          // Update the current active market watch
          this.activeMarketWatch = watch.MarketWatchID;

          // Update all market watches to reflect the new default
          this.marketWatches = this.marketWatches.map(mw => ({
            ...mw,
            IsDefault: mw.MarketWatchID === watch.MarketWatchID
          }));

          Swal.fire({
            title: successTitle,
            text: successText,
            icon: 'success',
            confirmButtonText: confirmBtnText
          });
        } catch (error) {
          Swal.fire({
            title: errorTitle,
            text: errorText,
            icon: 'error',
            confirmButtonText: confirmBtnText
          });
        }
      }
    });
  }
  GetClientMarketWatchSymbols(MarketWatchID: string, relationCode: string) {
    return this.http
      .get<any[]>(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientMarketWatchSymbols?MarketWatchID=${MarketWatchID}&relationCode=${relationCode}`,
        {
          headers: new HttpHeaders({
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          }),
        }
      )
  }
  async selectMarketWatch(watch: any, symbol: string): Promise<void> {
    // Close dropdown for this symbol
    this.openDropdowns[symbol] = false;

    // Early return if we're in the middle of deleting a market watch
    if (this.deletingMarketWatch) {
      this.deletingMarketWatch = false;
      return;
    }

    try {

      // First, try to get current symbols from the endpoint
      let currentSymbols: string[] = [];

      try {
        const endpointResponse = await this.http.get<any>(
          `${UrlConstants.backofficeUrl}/api/Client/GetClientMarketWatchSymbols?MarketWatchID=${watch.MarketWatchID}&relationCode=${this.relationCode}`,
          {
            headers: new HttpHeaders({
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            }),
          }
        ).toPromise();

        // If endpoint returns symbols, use them as currentSymbols
        if (endpointResponse && endpointResponse.length > 0) {
          currentSymbols = endpointResponse.map((item: any) => item.symbol || item.Symbol || item); // Adjust property name as needed
        } else {
          // Fallback to service if endpoint returns empty or no results
          currentSymbols = this.favService.favCompaniesSymbols.getValue() ?? [];
        }

      } catch (endpointError) {
        // Fallback to service if endpoint fails
        currentSymbols = this.favService.favCompaniesSymbols.getValue() ?? [];
      }

      // Create a working copy
      const updatedSymbols = [...currentSymbols];

      // Toggle symbol presence in the market watch
      const symbolIndex = updatedSymbols.indexOf(symbol);
      const isSymbolInWatch = symbolIndex > -1;

      if (isSymbolInWatch) {
        // Remove symbol from market watch
        updatedSymbols.splice(symbolIndex, 1);
      } else {
        // Add symbol to market watch
        updatedSymbols.push(symbol);
      }

      // Update the market watch with the new symbol list
      await this.updateMarketWatchSymbols(updatedSymbols, watch, symbol, isSymbolInWatch);

    } catch (error) {

      // Show user-friendly error message
      this.showErrorToast(
        this.translate.instant("market-watch-update-failed"),
        this.translate.instant("error")
      );

      // Optionally, you might want to revert any UI changes here
      // For example, if you have any loading states or optimistic updates
    }
  }

  private async updateMarketWatchSymbols(
    symbols: string[],
    watch: any,
    symbol: string,
    wasRemoving: boolean
  ): Promise<void> {
    try {
      // Call the updateFavs method and wait for it to complete
      // Note: You might need to modify updateFavs to return a Promise
      await this.favService.updateFavs(
        symbols,
        watch.MarketWatchID,
        watch.MarketWatchName,
        false
      );

      // Show success message
      const actionText = wasRemoving ? 'removed-from' : 'added-to';
      this.showSuccessToast(
        this.translate.instant(`symbol-${actionText}-watchlist`, {
          symbol,
          watchName: watch.MarketWatchName
        })
      );

    } catch (error) {
      // If update fails, we should revert the optimistic UI update
      throw error; // Re-throw to be handled by the calling method
    }
  }

  private showErrorToast(message: string, title: string): void {
    this.toastr.error(message, title, {
      positionClass: "toast-bottom-right",
      closeButton: true,
      timeOut: 5000,
      titleClass: "toast-error-title",
      messageClass: "toast-error-message",
    });
  }

  private showSuccessToast(message: string): void {
    this.toastr.success(message, '', {
      positionClass: "toast-bottom-right",
      closeButton: true,
      timeOut: 3000,
      titleClass: "toast-success-title",
      messageClass: "toast-success-message",
    });
  }


 ngOnInit() {
  this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
  this.relationCode = this.accList?.[0]?.relationCode ?? '';
  this.AccFullMarket = this.accService.isFullMarketUser.getValue() == false;

  this.isDarkTheme = localStorage.getItem("darktheme") === "dark";

  this.columns = this._gridService.getMarketWatchColumns() || this.allFilters;
    // Call getAllMarketWatches and wait for the result
  this.favService.getAllMarketWatches();

  // Wait for marketWatches to be populated
  this.favService.marketWatches
    .pipe(filter(watches => watches && watches.length > 0))
    .subscribe((watches) => {
      if (!this.isMarketUser) {
        this.defaultMarketWatch = watches.find(watch => watch.IsDefault) || watches[0];
        this.marketWatches = this.defaultMarketWatch ? [this.defaultMarketWatch] : [];
        this.activeMarketWatch = this.defaultMarketWatch || null;
        this.favService.setActiveMarketWatch(this.activeMarketWatch);
        this.selectMarketWatchList(this.activeMarketWatch);
      } else {
        this.fetchTodayActive();
        this.marketWatches = watches;
        this.defaultMarketWatch = watches.find(watch => watch.IsDefault);
        this.activeMarketWatch = this.defaultMarketWatch || watches[0];
        this.selectMarketWatchList(this.activeMarketWatch);
        this.favSymbols = this.activeMarketWatch?.symbols || [];
      }
    });


    if(this.isMarketUser) this.fetchTodayActive();

  // Subscribe to isFullMarketUser first
  this.accService.isFullMarketUser.subscribe((isMarket) => {
    this.isMarketUser = isMarket;
    if (!isMarket) {
      this.state = "Favorites";
      this.favView = "table";
    }
    else{
      this.state = "Most Active";
      this.favView = "table";
    }
  });


}


  updateCols() {
    this._gridService.saveMarketWatchColumns(this.columns);
    this.WindowResize();
  }

  sendCompanySymbol(symbol, reuters, nameEn, nameAr, wasChanged) {
    this.selectedSymbol = symbol;
    this.fireFunction(symbol, reuters, nameEn, nameAr, wasChanged);
  }

  addWidgett(event) {
    let obj = JSON.parse(event);
    this._gridService.addGeneric(obj.name, false);
    this.addWidget(obj.name, obj.companyData, obj.isLinked);
  }
  bidsAsks(company) {
    let obj = {
      reuters: company.Reuters,
      symbol: company.SYMBOL_CODE,
      nameEn: company.ENG_NAME,
      name: company.ARB_NAME,
    };
    this._gridService.addGeneric("market-depth", false);
    this.addWidget("market-depth", obj, false);
  }

  openChart(company, e) {
    e.stopPropagation();
    let obj = {
      reuters: company.Reuters,
      symbol: company.SYMBOL_CODE,
      nameEn: company.ENG_NAME,
      name: company.ARB_NAME,
    };
    this.addWidget("chart", obj, false);
  }

  fetchFavs() {
    this.tableView = "favorites";
    this.state = "Favorites";
    this.saveState();

    this.isFavsLoading = true;

    this.favService.fetchFavs(this.activeMarketWatch).subscribe((res) => {
    });
    this.favService.favCompanies.subscribe((res) => {
      this.favCompaniesWithUpdates.data = res;
      this.favCompaniesWithUpdates.sort = this.sort;
      this.isFavsLoading = false;
    });
    this.favCompaniesWithUpdates.sort = this.sort;
  }
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }
  toggleAddFavorite(): void {
    this.showAddFavorite = !this.showAddFavorite;
  }

  createFavorite(symbol: string, favName: string): void {
    if (favName.trim()) {
      this.openDropdowns[symbol] = false;
      const symbols = [symbol];
      this.favService.updateFavs(symbols, 0, favName.trim(), false);
      var title = '';
      this.translate.currentLang != "ar" ? title = `${favName} Favorite list has been created` : title = `${favName} تم إنشاء القائمة المفضلة`;
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: title,
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        customClass: {
          popup: this.isDarkTheme ? 'swal-toast-dark' : 'swal-toast',
        },
        showCloseButton: true
      });

    }
  }

  selectMarketWatchList(watch: any): void {
    this.activeMarketWatch = watch;
    this.dropdownOpen = false;
    this.favService.setActiveMarketWatch(watch);
    this.fetchFavs();
  }
  onStarClick(event: MouseEvent, symbol: string) {
    if (this.accService.isFullMarketUser.getValue() == false) {
      this.handleMarketWatchSelection({ watch: this.activeMarketWatch, symbol });
      this.closeDropdown()
    }
    else {
      if (this.tableView === "favorites") {
        this.handleMarketWatchSelection({ watch: this.activeMarketWatch, symbol });
        this.closeDropdown();
        return;
      }
      this.selectedItem = { symbol };
      this.dropdownX = event.clientX;
      this.dropdownY = event.clientY;
      this.dropdownOpen = true;
      event.stopPropagation();
    }
  }

  deleteMarketWatch(marketWatchID: string): void {


    const title = this.translate.currentLang !== "ar" ? 'Are you sure?' : 'هل انت متأكد؟';
    const text = this.translate.currentLang !== "ar" ? 'Do you want to delete this favorite list?' : 'هل تريد حذف هذه القائمة المفضلة؟';
    const confirmBtn = this.translate.currentLang !== "ar" ? 'Yes, delete it!' : 'نعم، احذفه!';
    const cancelBtn = this.translate.currentLang !== "ar" ? 'Cancel' : 'إلغاء';
    const successTitle = this.translate.currentLang !== "ar" ? 'Deleted!' : 'تم الحذف!';
    const successText = this.translate.currentLang !== "ar" ? 'Favorite List deleted successfully.' : `تم حذف القائمة بنجاح`;
    const errorTitle = this.translate.currentLang !== "ar" ? 'Error!' : 'خطأ!';
    const errorText = this.translate.currentLang !== "ar" ? 'Failed to delete favorite list.' : 'فشل في حذف القائمة المفضلة.';
    const confirmBtnText = this.translate.currentLang !== "ar" ? 'OK' : 'حسنا';


    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmBtn,
      cancelButtonText: cancelBtn
    }).then((result) => {
      if (result.isConfirmed) {
        this.favService.deleteMarketWatch(marketWatchID).subscribe(
          (response) => {
            this.marketWatches = this.marketWatches.filter(
              (watch) => watch.MarketWatchID !== marketWatchID
            );
            this.deletingMarketWatch = true;
            Swal.fire({
              title: successTitle,
              text: successText,
              icon: 'success',
              confirmButtonText: confirmBtnText
            }).then((result) => {
              if (result.isConfirmed) {
                // If the deleted market watch was active, select the first available one
                            if (this.marketWatches.length > 0 && this.activeMarketWatch.MarketWatchID === marketWatchID) {
              this.selectMarketWatchList(this.marketWatches[0]);
            }
                else {
                  this.tableView = "market";
                  this.state = "All Market";
                  this.saveState();
                }
              }
            });



          },
          (error) => {
            Swal.fire({
              title: errorTitle,
              text: errorText,
              icon: 'error',
              confirmButtonText: confirmBtnText
            });
          }
        );
      }
    });
  }


  closeDropdown() {
    this.dropdownOpen = false;
  }

  addFavoriteList({ symbol, name }) {
    this.createFavorite(symbol, name);
    this.closeDropdown();
  }

  handleMarketWatchSelection({ watch, symbol }) {
    this.selectMarketWatch(watch, symbol)
    this.closeDropdown();
  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 10);
  }

  fetchEGX(egx) {
    this.tableView = "market";
    this.state = egx;
    this.saveState();

    this.isCompaniesLoading = true;

    this.companiesWithUpdates.data = [];

    this._service.fetchEGX(egx).subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companiesWithUpdates.data = res as CompanyListWithUpdates[];
      this.companiesWithUpdates.sort = this.sort;

      this.WindowResize();
    });
  }

  fetchTodayActive() {
    this.tableView = "market";
    this.state = "Most Active";
    this.saveState();

    this.companies.data = [];

    this.isCompaniesLoading = true;

    this._service.fetchTodayMarketWatch().subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companiesWithUpdates.data = res as CompanyListWithUpdates[];
      this.companiesWithUpdates.sort = this.sort;

      this.WindowResize();
    });
  }

  fetchCompanies() {
    this.tableView = "market";
    this.state = "All Market";
    this.saveState();

    this.isCompaniesLoading = true;
    this.companiesWithUpdates.data = [];

    this._service.fetchAllMarketWatch().subscribe((res: CompanyListWithUpdates[]) => {
      this.isCompaniesLoading = false;
      this.companiesWithUpdates.data = res.filter(
        (company) => company.MARKET_ID != "INDX"
      );
      this.companiesWithUpdates.sort = this.sort;

      this.WindowResize();
    });
  }

  fetchMarket(x) {
    this.tableView = "market";
    this.state = x;
    this.saveState();

    this.isCompaniesLoading = true;
    this.companiesWithUpdates.data = [];

    this._service.fetchEgxMarket(x).subscribe((res: CompanyListWithUpdates[]) => {
      this.isCompaniesLoading = false;
      this.companiesWithUpdates.data = res;
      this.companiesWithUpdates.sort = this.sort;

      this.WindowResize();
    });
  }

  saveState() {
    this._gridService.updateMarketWatchState(this.state);
  }

  get colsss() {
    return this.columns.filter((col) => col.isChecked);
  }

  get colss() {
    return [
      "Reuters",
      this.translate.currentLang == "ar" ? "arb_shortname" : "eng_shortname",
      ...this.colsss.map((col) => col.prop),
    ];
  }

  toggle(col, event) {
    col.isChecked = !col.isChecked;

    this.WindowResize();
    this.updateCols();
  }

  // get statee() {
  //   return this._gridService.getMarketWatchState(this.id);
  // }

  isFav(symbol) {
    return this.favService.isFav(symbol);
  }
  // isFav(symbol: any): boolean {

  //   // Check if the favorites list exists and is an array
  //   if (!this.favService.favCompaniesSymbols || !Array.isArray(this.favService.favCompaniesSymbols)) {
  //     return false;
  //   }

  //   return this.favService.favCompaniesSymbols.includes(symbol);  // Check if symbol is in the favorites list
  // }

  toggleDropDown(symbol) {
    this.openDropdowns[symbol] = !this.openDropdowns[symbol];
  }

  toggleFav(symbol, marketWatchId) {
    this.openDropdowns[symbol] = !this.openDropdowns[symbol];
    this.favService.toggleFav(symbol, marketWatchId);
  }

  orderBuy(company, isSell) {
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { symbol: company, type: isSell },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }
}
